import { StripePaymentIntentAPIResponseType } from 'types/productPackage';
import { api } from 'utils/api';
import { CreateIntentDto } from 'utils/GeneratedApi';

const createStripePaymentIntent = async (
  payload: CreateIntentDto,
): Promise<StripePaymentIntentAPIResponseType> => {
  const response = await api.stripeControllerCreateIntentV1(payload, {});

  return (response.data as unknown as StripePaymentIntentAPIResponseType) || response.error;
};

export default createStripePaymentIntent;
